import Vue from 'vue'
import Router from 'vue-router'
// import Home from '@/pages/index.vue'
import HomePage from '@/pages/index.vue'
// import e1 from '@/pages/e1.vue'
import e2 from '@/pages/e2.vue'
// import e3 from '@/pages/e3.vue'
// import e4 from '@/pages/e4.vue'
// import e5 from '@/pages/e5.vue'
// import e6 from '@/pages/e6.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      // name: 'Home',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'HomePage',
      component: HomePage
    },
    {
      path: '/e1',
      name: 'e1',
      // component: e1
      component: () => import(/* webpackChunkName: "about" */ '@/pages/e1.vue')
    },
    {
      path: '/e2',
      name: 'e2',
      component: e2
    },
    {
      path: '/e3',
      name: 'e3',
      component: () => import(/* webpackChunkName: "about" */ '@/pages/e3.vue')
    },
    {
      path: '/e4',
      name: 'e4',
      component: () => import(/* webpackChunkName: "about" */ '@/pages/e4.vue')
    },
    {
      path: '/e5',
      name: 'e5',
      component: () => import(/* webpackChunkName: "about" */ '@/pages/e5.vue')
    }
    ,
    {
      path: '/e6',
      name: 'e6',
      component: () => import(/* webpackChunkName: "about" */ '@/pages/e6.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js